// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CompassFilledSvg from "@fishx/icons-svg/es/asn/CompassFilled";
import FishxIcon from '../components/FishxIcon';

var CompassFilled = function CompassFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CompassFilledSvg
  }));
};

CompassFilled.displayName = 'CompassFilled';
export default React.forwardRef(CompassFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CompassFilled.js
// module id = 2296
// module chunks = 0